<script>
import { Line } from 'vue-chartjs';

export default {
  extends: Line,
  props: {
    chartdata: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  watch: {
    chartdata: {
      handler(value) {
        if (value) {
          this.renderChart(this.chartdata, this.options);
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.renderChart(this.chartdata, this.options);
  },
};
</script>
